"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ShieldCheck, BadgeCheck, Sparkles, ClipboardCheck } from "lucide-react";
interface ReasonItem {
  id: string;
  title: string;
  description: string;
  icon: React.ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
}
const reasons: ReasonItem[] = [{
  id: "honest-advice",
  title: "Honest advice",
  description: "We tell you what your property actually needs, nothing more.",
  icon: ShieldCheck
}, {
  id: "reliable-workmanship",
  title: "Reliable workmanship",
  description: "Turning up when we say we will and finishing on schedule.",
  icon: BadgeCheck
}, {
  id: "clean-and-tidy",
  title: "Clean & tidy",
  description: "We treat your home with respect and leave it spotless.",
  icon: Sparkles
}, {
  id: "free-quotes",
  title: "Free, no-obligation quotes",
  description: "Clear, fair pricing before any work starts.",
  icon: ClipboardCheck
}];
export default function WhyChooseFirststop() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="why-choose-firststop" className="bg-[#F7F5F1] py-20 md:py-28 overflow-hidden" ref={ref}>
      <div className={`max-w-[1280px] mx-auto px-6 lg:px-12 transition-all duration-1000 ease-out motion-reduce:transition-none motion-reduce:transform-none ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-bold uppercase tracking-widest text-primary mb-3">
            WHY CHOOSE US
          </p>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-secondary-foreground">
            Why Southampton Homeowners Choose Firststop
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map(item => {
          const Icon = item.icon;
          return <div key={item.id} className="group flex flex-col items-center text-center p-8 bg-card rounded-[14px] border border-border/80 shadow-[0_4px_20px_-2px_rgba(21,25,29,0.06)] transition-all duration-300 motion-reduce:transition-none hover:-translate-y-1.5 motion-reduce:hover:translate-y-0 hover:shadow-[0_12px_30px_-4px_rgba(21,25,29,0.12)] h-full">
                <div aria-hidden="true" className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center text-primary mb-6 transition-transform duration-300 motion-reduce:transition-none group-hover:scale-105">
                  <Icon className="w-7 h-7" strokeWidth={1.75} />
                </div>
                <h3 className="font-default text-xl font-bold text-secondary-foreground mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-foreground/80 text-base leading-relaxed mt-auto">
                  {item.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}